import { render, staticRenderFns } from "./PartyDetails.vue?vue&type=template&id=0a6c6723"
import script from "./PartyDetails.vue?vue&type=script&lang=js"
export * from "./PartyDetails.vue?vue&type=script&lang=js"
import style0 from "./PartyDetails.vue?vue&type=style&index=0&id=0a6c6723&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports